import React, { useCallback } from "react";
import * as d3 from "d3";
import { BarChartMergedData } from "@evergis/charts";

import { ColorBox, Tooltip, TooltipFlex, TooltipTip, TooltipTitle } from "../styled";

export const useRenderBarTooltip = () => {
  const format = d3.format(",");

  return useCallback(
    (bar: BarChartMergedData) => {
      const [{ value, color, groupName }] = bar;

      return (
        <Tooltip transform="translate(0, -6px)">
          <TooltipTip />
          <TooltipTitle>{groupName}</TooltipTitle>
          <TooltipFlex>
            <ColorBox color={color} />
            {format(Number(value.toFixed(2)))}
          </TooltipFlex>
        </Tooltip>
      );
    },
    [format],
  );
};
